import { MEETING_FORMATS } from '../session/Session'

export enum VIDEO_PLATFORM {
  LYRA = 'LYRA',
  EXTERNAL = 'EXTERNAL',
}

export const DEFAULT_VIDEO_PLATFORM = VIDEO_PLATFORM.EXTERNAL

export interface ModalityPreferences {
  modalityPreferences: Array<MEETING_FORMATS>
}

export const MODALITY_DEFAULT_PREFERENCES: ModalityPreferences = {
  modalityPreferences: [MEETING_FORMATS.VIDEO, MEETING_FORMATS.IN_PERSON],
}

export interface ModalityQuestionGroups {
  modalityQuestionGroups: Array<ModalityQuestionGroup>
}

export interface ModalityQuestionGroup {
  id: string
  header: string
  questions: ModalityQuestion[]
  feedbackByCount?: FeedbackByCounts | null
  feedbackByResponseMatrix?: FeedbackByResponseMatrix[] | null
}

export interface FeedbackByResponseMatrix {
  responses: Response[]
  feedbackText: string
  feedbackId: string
}

interface Response {
  questionId: string
  response: boolean
}

interface FeedbackByCounts {
  [key: string]: FeedbackByCount
}

interface FeedbackByCount {
  feedbackId: string
  feedbackText: string
}

export interface ModalityQuestion {
  id: string
  question: string
}

export interface ModalitySurveyStatus {
  previousRecommendations?: Array<MEETING_FORMATS> | null
  surveyNeeded: boolean
}

export interface ModalitySurveyQuestionGroupPreferences {
  recommendations: Array<MEETING_FORMATS>
}

export interface SurveyQuestionGroup {
  pageResponses: PageResponse[]
}

export interface PageResponse {
  pageId?: string
  feedbackId: string
  responses: Response[]
}

export interface Answers {
  [key: string]: boolean
}
